<template>
  <b-row>
    <b-table 
      v-if="titularesList.length > 0" 
      bordered striped responsive 
      :items="titularesList"
      :fields="fieldsTitulares"
    >
      <template #cell(daCobertura)="data">
        <div class="text-center">
          <i style="font-size: 20px;" :class="data.item.daCobertura
            ? 'fa-solid fa-circle-check text-success'
            : 'fa-solid fa-circle-xmark text-danger'" />
        </div>
      </template>

      <template #cell(padreSoltero)="data">
        <div class="text-center">
          <i style="font-size: 20px;" :class="data.item.padreSoltero
            ? 'fa-solid fa-circle-check text-success'
            : 'fa-solid fa-circle-xmark text-danger'" />
        </div>
      </template>

      <template #cell(acciones)="data">
        <div 
          v-if="!onlyView" 
          class="d-flex justify-content-center"
        >
          <b-button 
            variant="primary" 
            size="sm" 
            style="cursor: pointer;"
            @click="onEditTitular(data.item)"
          >
            <font-awesome-icon icon="user-pen" style="color: blue;" />
          </b-button>

          <b-button 
            variant="danger" 
            size="sm" 
            style="cursor: pointer;" 
            @click="removeItemTitular(data.item)"
          >
            <font-awesome-icon icon="circle-xmark" style="color: red;" />
          </b-button>
        </div>

      </template>
    </b-table>

    <b-alert 
      v-if="titularesList.length == 0 && !pacienteSeDaCobertura" 
      variant="danger" 
      show class="text-center col-12"
      style="padding: 40px; font-size: 20px;">
      <i class="fa-solid fa-triangle-exclamation" />
      No existe ningun titular registrado
    </b-alert>

    <b-alert 
      v-if="pacienteSeDaCobertura" 
      variant="info" 
      show class="text-center col-12"
      style="padding: 40px; font-size: 20px;">
      <i class="fa-solid fa-person" />
      El paciente es el titular del contrato
    </b-alert>

  </b-row>
</template>

<script>
export default {
  name: 'TitularesTable',

  props:{
    titularesList:{
      type: Array,
      default: () => []
    },


    onlyView: {
      type: Boolean,
      default: false
    },
  },

  data(){
    return {

      fieldsTitulares: [
        { key: 'nombres',      label: 'Nombres',       thClass: 'text-center' },
        { key: 'edad',         label: 'Edad (Años)',   thClass: 'text-center' },
        { key: 'daCobertura',  label: 'Cobertura',     thClass: 'text-center' },
        { key: 'padreSoltero', label: 'Madre soltera', thClass: 'text-center' },
        { key: 'telefono',     label: 'Telefono',      thClass: 'text-center' },
        // { key: 'acciones',     label: 'acciones',      thClass: 'text-center', tdClass: 'text-right', sortable: true },
      ],
    }
  },


  computed:{
    pacienteSeDaCobertura(){
      return this.titularesList.length === 0
    }
  }
}
</script>
